import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Início', href: '/' },
    { name: 'Produtos', href: '/produtos' },
    { name: 'Receitas', href: '/receitas' },
    { name: 'Catálogos', href: '/catalogos' }
  ];

  const company = [
    { name: 'Sobre Nós', href: '/sobre' },
    { name: 'Contato', href: '/contato' },
    { name: 'Política de Privacidade', href: '#' },
    { name: 'Termos de Uso', href: '#' }
  ];

  const products = [
    { name: 'Culinários', href: '/produtos?categoria=culinarios' },
    { name: 'Sobremesas', href: '/produtos?categoria=sobremesas' },
    { name: 'Bebidas', href: '/produtos?categoria=bebidas' },
    { name: 'Linha Industrial', href: '/produtos?categoria=industrial' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src="https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/133a8deae29cbecd66fda83e37f51621.png" 
              alt="Tecnutri" 
              className="h-10 w-auto"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Há mais de 20 anos oferecendo produtos de qualidade para alimentação empresarial e hospitalar.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/tecnutri.alimentos?locale=pt_BR" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-500 transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://www.instagram.com/tecnutrifoodservice/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-500 transition-colors">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="https://br.linkedin.com/company/sustentare-produtos-alimentícios" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-500 transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="https://www.youtube.com/@tecnutrifoodservice" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-500 transition-colors">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
              <Link to="/contato" className="text-gray-400 hover:text-red-500 transition-colors">
                <i className="ri-whatsapp-line text-xl"></i>
              </Link>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Links Rápidos</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href} 
                    className="text-gray-300 hover:text-red-500 transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Produtos</h3>
            <ul className="space-y-2">
              {products.map((product) => (
                <li key={product.name}>
                  <Link 
                    to={product.href} 
                    className="text-gray-300 hover:text-red-500 transition-colors text-sm"
                  >
                    {product.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Empresa</h3>
            <ul className="space-y-2">
              {company.map((item) => (
                <li key={item.name}>
                  <Link 
                    to={item.href} 
                    className="text-gray-300 hover:text-red-500 transition-colors text-sm"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Contact Info */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex items-center space-x-3">
              <i className="ri-phone-line text-red-500 text-xl"></i>
              <div>
                <p className="text-sm text-gray-400">Telefone</p>
                <p className="text-white">(19) 3852-8200</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <i className="ri-mail-line text-red-500 text-xl"></i>
              <div>
                <p className="text-sm text-gray-400">E-mail</p>
                <p className="text-white">contato@sustentare.com.br</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <i className="ri-map-pin-line text-red-500 text-xl"></i>
              <div>
                <p className="text-sm text-gray-400">Endereço</p>
                <a 
                  href="https://www.google.com/maps/place/Estr.+Mun.+Fioravante+Carlotti,+1901,+Pedreira+-+SP,+13920-000/@-22.7168341,-46.8881059,1003m/data=!3m2!1e3!4b1!4m6!3m5!1s0x94c8de602e0c7455:0x7ea2b102dbd70022!8m2!3d-22.7168391!4d-46.885531!16s%2Fg%2F11svtdfhz6?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-red-500 transition-colors cursor-pointer"
                >
                  Pedreira - SP
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} Tecnutri. Todos os direitos reservados.
          </p>
          <div className="mt-4 md:mt-0">
            <a 
              href="https://wa.me/19995563309"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-red-500 transition-colors text-sm"
            >
              M.PLACIDINO
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
